import type { TripListResponse } from "../../types/operations/tripList.type";

export const mockTripList = {
  default: {
    summary: {
      today: { trips: 1, bills: 15, weight: 13834 },
      tomorrow: { trips: 0, bills: 0, weight: 0 },
      enRoute: { trips: 1, bills: 15, weight: 13834 },
      checkedIn: { trips: 1, bills: 15, weight: 13834 },
      closingSoon: { trips: 0, bills: 0, weight: 0 },
    },
    trips: [
      {
        bookingNumber: "88965478",
        tripNumber: 10024384,
        loadingDate: "2026-04-01",
        hasCheckedIn: true,
        checkedInTimeUtc: "2026-02-02T07:17:17.338238",
        trailerNumber: "DYLT170381",
        tractorNumber: null,
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 114,
        destinationSicCode: "DAL",
        stopSicId: null,
        stopSicCode: null,
        estimatedCloseTimeUtc: "2026-04-02T05:30:00",
        actualCloseTimeUtc: "2026-04-01T20:51:10.724429",
        arrivalEtaUtc: null,
        bills: 15,
        cube: 78,
        pallets: 21,
        pieces: 18,
        handlingUnits: 0,
        weight: 13834,
        carrier: { name: "C R ENGLAND INC" },
        dotNumber: null,
        mcNumber: null,
        status: { id: 26, name: "ENRT" as const },
        currentLocation: { title: null, subtext: null },
        closeSoon: false,
        pastCloseTime: false,
        driverCheckIn: {
          tractorNumber: "555",
          emptyTrailerDrop: true,
          carrierId: null,
          trailerNumber: "111",
          equipmentId: null,
          driver1: {
            id: 66121,
            driverId: 0,
            driverName: "BASILO JESUS PEREZ",
            phoneNumber: "817-435-3846",
            licenseNumber: null,
            licenseState: "TX",
          },
          driver2: {
            id: 66122,
            driverId: 0,
            driverName: "SOLO",
            phoneNumber: null,
            licenseNumber: null,
            licenseState: null,
          },
        },
      },
    ],
  },
} satisfies Record<string, TripListResponse>;
